import _ from 'lodash';
import React from 'react';
import { Image } from 'console-kit';

import FIELD_TEMPLATES from './fieldTemplates';

const TILE_STYLES = {
  BUTTON:     'button',
  CARD:       'card',
  CHECKBOX:   'checkbox',
  CIRCLE:     'circle',
  FULL_BLEED: 'full-bleed',
  RADIO:      'radio',

  //rating specific tile styles
  RATING_STAR:   'rating-star',
  RATING_NUMBER: 'rating-number',
  RATING_SLIDER: 'rating-slider',
  DROPDOWN:      'dropdown',
};

TILE_STYLES.ALL = _.values(TILE_STYLES);

TILE_STYLES.CONFIGS = {
  [TILE_STYLES.CHECKBOX]: {
    text:  'Checkbox',
    value: TILE_STYLES.CHECKBOX,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/checkbox-style-checkbox.svg'} />,
  },
  [TILE_STYLES.BUTTON]: {
    text:  'Button',
    value: TILE_STYLES.BUTTON,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/radio-style-button.svg'} />,
  },
  [TILE_STYLES.CARD]: {
    text:  'Card',
    value: TILE_STYLES.CARD,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/radio-style-card.svg'} />,
  },
  [TILE_STYLES.CIRCLE]: {
    text:  'Circle',
    value: TILE_STYLES.CIRCLE,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/radio-style-circle.svg'} />,
  },
  // TODO Will be added shortly after the initial release so commenting out for now
  [TILE_STYLES.FULL_BLEED]: {
    text:  'Full-bleed',
    value: TILE_STYLES.FULL_BLEED,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/radio-style-full-bleed.svg'} />,
  },
  [TILE_STYLES.RADIO]: {
    text:  'Radio button',
    value: TILE_STYLES.RADIO,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/radio.svg'} />,
  },

  //rating specific tile styles
  [TILE_STYLES.RATING_STAR]: {
    text:  'Icon Rating',
    value: TILE_STYLES.RATING_STAR,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/rating/stars.svg'} />,
  },

  [TILE_STYLES.RATING_NUMBER]: {
    text:  'Number Scale',
    value: TILE_STYLES.RATING_NUMBER,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/rating/numbers.svg'} />,
  },

  [TILE_STYLES.RATING_SLIDER]: {
    text:  'Slider',
    value: TILE_STYLES.RATING_SLIDER,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/rating/slider.svg'} />,
  },
  [TILE_STYLES.DROPDOWN]: {
    text:                  'Dropdown',
    value:                 TILE_STYLES.DROPDOWN,
    image:                 <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/radio-style-dropdown.svg'} />,
    restrictedToTemplates: [FIELD_TEMPLATES.VERTICAL],
  },
};

TILE_STYLES.RADIO_LIST = [
  TILE_STYLES.CONFIGS[TILE_STYLES.RADIO],
  TILE_STYLES.CONFIGS[TILE_STYLES.BUTTON],
  TILE_STYLES.CONFIGS[TILE_STYLES.CARD],
  TILE_STYLES.CONFIGS[TILE_STYLES.CIRCLE],
];

TILE_STYLES.CHECKBOX_LIST = [
  TILE_STYLES.CONFIGS[TILE_STYLES.CHECKBOX],
  TILE_STYLES.CONFIGS[TILE_STYLES.BUTTON],
  TILE_STYLES.CONFIGS[TILE_STYLES.CARD],
  TILE_STYLES.CONFIGS[TILE_STYLES.CIRCLE],
];

TILE_STYLES.RATING_LIST = [
  TILE_STYLES.CONFIGS[TILE_STYLES.RATING_STAR],
  TILE_STYLES.CONFIGS[TILE_STYLES.RATING_NUMBER],
  TILE_STYLES.CONFIGS[TILE_STYLES.RATING_SLIDER],
];

TILE_STYLES.SWIPE_LIST = [TILE_STYLES.CONFIGS[TILE_STYLES.BUTTON], TILE_STYLES.CONFIGS[TILE_STYLES.CIRCLE]];

TILE_STYLES.MX_QUIZ_SINGLE_SELECT_LIST = [...TILE_STYLES.RADIO_LIST, TILE_STYLES.CONFIGS[TILE_STYLES.DROPDOWN]];

TILE_STYLES.MX_QUIZ_MULTI_SELECT_LIST = [...TILE_STYLES.CHECKBOX_LIST, TILE_STYLES.CONFIGS[TILE_STYLES.DROPDOWN]];

export default TILE_STYLES;
